import { render, staticRenderFns } from "./serviceRecord.vue?vue&type=template&id=59dbb250&scoped=true&"
import script from "./serviceRecord.vue?vue&type=script&lang=js&"
export * from "./serviceRecord.vue?vue&type=script&lang=js&"
import style0 from "./serviceRecord.vue?vue&type=style&index=0&id=59dbb250&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59dbb250",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
